import {DatamodelRoles} from "./UserManager.types";
import {IconContainer, MdView} from "@biron-data/react-components";
import React, {FunctionComponent, useCallback} from "react";
import styled from "styled-components";
import Language from "../../../language";
import {TooltipIconLayout, TooltipRowWithIcon} from "../../../themes/SharedStyledComponent";


export const getStarsDisplay = (starCount?: number) => {
  return starCount ? <DefinitionStarContainer>
    {[...Array(starCount).keys()].map((i) => <DefinitionStar key={`star-${i}`}>*</DefinitionStar>)}
  </DefinitionStarContainer> : <></>
}

const DefinitionStarContainer = styled.div`
    display: flex;
    align-content: center;
    align-items: center;
`

const DefinitionStar = styled.div`
    color: var(--primary);
`

const getPopoverRowWithIcon = (isEnabled: boolean,
                               languageArgs: {key: string, args?: any},
                               Icon: FunctionComponent,
starCount?: number,) => <TooltipRowWithIcon $layout={"row"} onClick={(e) => e.stopPropagation()}>
  <TooltipIconLayout>
    <IconContainer key={languageArgs.key} color={isEnabled ? "var(--primary)" : "var(--medium-grey)"}><Icon/></IconContainer>
  </TooltipIconLayout>
  <MdView padding={0} description={Language.get(`${languageArgs.key}.${isEnabled ? 'can' : 'cannot'}`, languageArgs.args)}/>
  {getStarsDisplay(starCount)}
</TooltipRowWithIcon>

export const useGetPopoverRowWithIcon = () =>
  useCallback((
  isEnabled: boolean,
  languageArgs: {key: string, args?: any},
  Icon: FunctionComponent,
starCount?: number,
) => getPopoverRowWithIcon(isEnabled, languageArgs, Icon, starCount), [])


export const getIsDatamodelManager = (roles?: DatamodelRoles[]) => Boolean(roles?.includes(DatamodelRoles.DATAMODEL_EXPLORER))
export const getIsDatamodelViewer = (roles?: DatamodelRoles[]) => {
  const isDatamodelManager = getIsDatamodelManager(roles)
  return roles?.includes(DatamodelRoles.DATAMODEL_VIEWER) || isDatamodelManager
}